import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import qs from 'qs'
import server from 'server/serverController2'
import { formatDate, removeItem } from 'utils/utils.js'

import TaskResultFormModal from 'components/containers/task/modal/TaskResultFormModal'
import TaskReportModal from 'components/containers/task/modal/TaskReportModal'
import AnimatedWindow from 'components/containers/common/AnimatedWindow'
import AnimatedWindowHeader from 'components/presenters/header/AnimatedWindowHeader'
import FeedGalleryList from 'components/presenters/feed/gallery/FeedGalleryList'
import FeedList from 'components/presenters/feed/detail/FeedList'

//commentModal
import TaskDetail from 'components/containers/task/TaskDetail'

import BottomModal from 'components/presenters/modal/BottomModal'
import CenterModal from 'components/presenters/modal/CenterModal'
import LottieLoader from 'components/containers/common/LottieLoader'

import uniThumbsUp from 'images/character/uni_thumbs_up-239x300.png'
import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'
import uniFail from 'images/character/uni_fail.png'
//lottieFile
import likeAnimation from 'images/lottiefile/like_animation_red.json'
import { useHistory } from 'react-router'

// 투두리스트 아이콘 누르면 나오는 페이지
export default function TaskListFeed({
  userNo,
  onEdit,
  onDelete,
  emptyTxt,
  hideReported,
  onFeedDetailShow,
  setSocialShareModalVisible,
}) {
  const history = useHistory()
  const feedItemPerReq = 50
  const commentItemPerReq = 5
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const [isLoading, setIsLoading] = useState(false)
  const [isEnd, setIsEnd] = useState(false)
  const [lastPosNo, setLastPosNo] = useState(null)
  const [commentsLastNumber, setCommentsLastNumber] = useState(null)
  const [feedList, setFeedList] = useState([])
  const [clickTimeout, setClickTimeout] = useState(null)
  const [currFeed, setCurrFeed] = useState(null)

  //BottomModalState
  const [bottomModalVisible, setBottomModalVisible] = useState(false)
  const [bottomModalDataList, setBottomModalDataList] = useState([])
  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  const [showFeedDetailList, setShowFeedDetailList] = useState(false)
  const [currentFeedNo, setCurrentFeedNo] = useState(null)

  //CommentState
  const [commentList, setCommentList] = useState([])
  const [commentValue, setCommentValue] = useState('')
  const [commentVisible, setCommentVisible] = useState(false)
  const [isCommentLoading, setIsCommentLoading] = useState(false)
  const [isCommentLoadEnd, setIsCommentLoadEnd] = useState(false)
  const [insertedCommentList, setInsertedCommentList] = useState([])
  const [isCommentSlideOn, setIsCommentSlideOn] = useState(true)

  //TaskReportModal
  const [reportModalVisible, setReportModalVisible] = useState(false)
  const [reportTargetNo, setReportTargetNo] = useState(null)

  //TaskResultFormModal
  const [showTaskResultForm, setShowTaskResultForm] = useState(false)
  const [targetTaskNo, setTargetTaskNo] = useState(null)

  //LikeAnimationState
  const [isLikeAnimation, setIsLikeAnimation] = useState(false)

  const [showMoreFeedNoList, setShowMoreFeedNoList] = useState([])
  const feedDescLimit = 26
  let isDeletingTaskResult = false
  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    loadUserArchive()
  }, [])
  useEffect(() => {
    if (onFeedDetailShow) {
      onFeedDetailShow(showFeedDetailList)
    }
  }, [showFeedDetailList])

  const loadUserArchive = () => {
    if (userNo) {
      let form = {
        order_by: 'no',
        limit: feedItemPerReq,
        order: 'desc',
        last_pos_no: lastPosNo,
      }
      if (hideReported === true) {
        form['hide_reported_user'] = true
        form['hide_reported_task'] = true
      }
      let queryString = qs.stringify(form)
      server.getRequestData(`users/${userNo}/archive?${queryString}`, (res) => {
        try {
          if (res.success !== 1) {
            setCenterModalVisible(true)
            setCenterModalDataList({ description: '로그인이 필요해요' })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              history.replace(`/social?redirect_path=${window.location.pathname}`)
            })
          }

          const jsonData = res.data
          const archiveList = jsonData['archive']
          if (archiveList) {
            setFeedList([...feedList, ...archiveList])
          }

          const showMoreNoList = []
          for (let i = 0; i < archiveList.length; ++i) {
            const newFeedItem = checkMoreBtnRequired(archiveList[i])
            if (newFeedItem['is_show_desc'] === true) {
              showMoreNoList.push(newFeedItem['no'])
            }
          }
          setShowMoreFeedNoList([...showMoreFeedNoList, ...showMoreNoList])

          if (archiveList.length > 0) {
            const lastItem = archiveList[archiveList.length - 1]
            setLastPosNo(lastItem['no'])
          }

          if (archiveList.length < feedItemPerReq) {
            setIsEnd(true)
          }
          setIsLoading(false)
        } catch (err) {
          console.log(err)
        }
      })
    }
  }

  const checkMoreBtnRequired = (feedItem) => {
    if (!feedItem['description']) {
      feedItem['is_show_desc'] = true
    } else {
      const feedDescriptions = feedItem['description'].split('\n')
      if (feedDescriptions[0].length > feedDescLimit) {
        feedItem['is_show_desc'] = false
      } else if (feedDescriptions.length > 1) {
        feedItem['is_show_desc'] = false
      } else {
        feedItem['is_show_desc'] = true
      }
    }
    return feedItem
  }

  const deleteFeedRequest = async (currTaskNo) => {
    if (isDeletingTaskResult === false) {
      isDeletingTaskResult = true
      const res = await server.deleteRequestData(`tasks/${currTaskNo}/result`)
      isDeletingTaskResult = false
      if (res?.success === 0) {
        setCenterModalVisible(true)
        const errData = res?.error?.res_data
        if (errData?.detail_code === 'PAYBACK_ALREADY_PROCESSED') {
          setCenterModalDataList({
            description: `환급챌린지 인증사진은\n 삭제가 불가능합니다.\n 관리자에게 문의해주세요.`,
          })
        } else {
          setCenterModalDataList({
            description: `투두리스트 삭제에 실패했어요.\n 나중에 다시 시도해주세요.`,
          })
        }
        setOnModalCancel(null)
        setOnModalComplete(() => () => setCenterModalVisible(false))
        return
      }
      const { deleted_item } = res.data
      handleDeleteTaskTrigger(deleted_item[0])
      setCenterModalVisible(false)
      if (onDelete) {
        onDelete(deleted_item[0]['task_no'])
      }
    }
  }

  const addLikeRequest = async (currTask) => {
    try {
      if (userInfo['isLogin'] === false) {
        //handleEmptyUserInfo();
        return
      }
      const resultData = await server.postRequestData(`tasks/${currTask['task_no']}/like`)
      if (resultData['success'] === 0) {
        return
      }
      setIsLikeAnimation(true)
      const { inserted_item } = resultData.data
      handleCreateLike(inserted_item['task_no'])

      setCurrentFeedNo(currTask['task_no'])
      setTimeout(() => {
        setIsLikeAnimation(false)
      }, 1500)
    } catch (error) {
      console.log(error)
    }
  }

  const deleteLikeRequest = async (currfeed) => {
    try {
      const resultData = await server.deleteRequestData(`tasks/${currfeed['task_no']}/like`)
      if (resultData['success'] === 0) {
        return
      }
      const { deleted_item } = resultData.data
      handleDeleteLike(deleted_item[0]['task_no'])
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateTask = (currFeedNo, proof, description) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['proof'] = proof
        feedItem['description'] = description
        feedItem['is_show_desc'] = true
        setShowMoreFeedNoList([...showMoreFeedNoList, feedItem['no']])
      }
    })

    setFeedList(feeds)
  }

  const handleCreateComment = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_comment'] =
          feedItem['total_comment'] !== null ? parseInt(feedItem['total_comment']) + 1 : 1
      }
    })
    setFeedList(feeds)
  }

  const handleDeleteComment = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_comment'] = parseInt(feedItem['total_comment']) - 1
      }
    })
    setFeedList(feeds)
  }

  const handleCreateLike = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_like'] = parseInt(feedItem['total_like']) + 1
        feedItem['liked_task'] = true
      }
    })
    setFeedList(feeds)
  }

  const handleDeleteLike = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_like'] = parseInt(feedItem['total_like']) - 1
        feedItem['liked_task'] = false
      }
    })
    setFeedList(feeds)
  }

  const handleOpenCommentModal = (currentFeed) => {
    if (userInfo['isLogin'] === false) {
      handleEmptyUserInfo()
      return
    }
    setCurrFeed(currentFeed)
    setCommentVisible(true)
    setIsCommentSlideOn(true)
  }

  const handleOpenReportModal = (currentFeed) => {
    if (userInfo['isLogin'] === false) {
      handleEmptyUserInfo()
      return
    }
    setReportTargetNo(currentFeed['task_no'])
    setReportModalVisible(true)
    setBottomModalVisible(false)
  }

  const handleDeleteTaskTrigger = (targetTask) => {
    const feeds = [...feedList]
    let index = 0
    for (let i = 0; i < feeds.length; ++i) {
      if (feeds[i]['task_no'] === targetTask['task_no']) {
        index = i
      }
    }
    const reloadFeeds = removeItem(feeds, index)
    setFeedList(reloadFeeds)
  }

  const handleReportComplete = () => {
    setCenterModalVisible(true)
    setCenterModalDataList({
      type: 'callback',
      title: '인증샷 신고 완료',
      description:
        '신고접수가 완료되었어요.\n모티너스 운영팀에서 검토 후,\n삭제/미인증 처리하겠습니다.',
    })
    setOnModalComplete(() => () => {
      setCenterModalDataList({})
      setOnModalComplete(null)
      setCenterModalVisible(false)
    })
  }

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight
    if (bottom && !isEnd) {
      if (!isLoading) {
        setIsLoading(true)
        loadUserArchive()
      }
    }
  }

  const handleEmptyUserInfo = () => {
    setCenterModalDataList({ type: 'callback', description: '로그인이 필요해요' })
    setOnModalComplete(() => () => history.replace('/social'))
    setOnModalCancel(() => () => setCenterModalVisible(false))
    setCenterModalVisible(true)
  }

  const handleDoubleClick = (currTask) => {
    if (clickTimeout !== null) {
      clearTimeout(clickTimeout)
      if (currTask['liked_task'] === false) {
        setCurrentFeedNo(currTask['task_no'])
        addLikeRequest(currTask)
        setClickTimeout(null)
        return
      }
    } else {
      setClickTimeout(
        setTimeout(() => {
          clearTimeout(clickTimeout)
          setClickTimeout(null)
        }, 500),
      )
    }
  }

  const handleEditTask = (param) => {
    setShowTaskResultForm(true)
    setTargetTaskNo(param['task_no'])
    setBottomModalVisible(false)
  }
  const handleCenterModalState = (param) => {
    setCenterModalDataList({
      type: 'callback',
      title: '게시물 삭제',
      description: '게시물을 삭제하시겠어요?\n적립된 포인트와\n스티커도 함께 사라져요.',
    })
    setOnModalComplete(() => () => {
      deleteFeedRequest(param['task_no'])
      setCommentVisible(false)
    })
    setOnModalCancel(() => () => setCenterModalVisible(false))
    setCenterModalVisible(true)
    setBottomModalVisible(false)
  }
  const handleBottomModalState = (currentFeed) => {
    let optionMenu = []
    if (userInfo['role'] === 'admin' || userInfo['id'] === currentFeed['user_no']) {
      if (currentFeed['task_date'] >= formatDate()) {
        // optionMenu.push({
        // 	type: "callback",
        // 	text: "게시물 수정",
        // 	callback: handleEditTask,
        // 	callbackParam: currentFeed,
        // 	style: { color: "#000000" },
        // })
      }
      optionMenu.push({
        type: 'callback',
        text: '게시물 삭제',
        callback: handleCenterModalState,
        callbackParam: currentFeed,
        style: { color: '#DE0000' },
      })
    }
    if (userInfo['id'] !== currentFeed['user_no']) {
      optionMenu.push({
        type: 'callback',
        text: '인증샷 신고하기',
        callback: () => handleOpenReportModal(currentFeed),
        style: { color: '#DE0000' },
      })
      // optionMenu.push({ type: 'callback', text: '악성 유저 신고하기', callback: () => handleOpenUserReportModal(currentFeed) , style: {color: '#DE0000'}})
    }

    setBottomModalDataList(optionMenu)
    setBottomModalVisible(true)
  }
  const loadNextComments = (currentFeed) => {
    if (!isCommentLoading && !isCommentLoadEnd) {
      setIsCommentLoading(true)
      server.getRequestData(
        `tasks/${currentFeed['task_no']}/comments?last_pos_no=${commentsLastNumber}&limit=${commentItemPerReq}`,
        (res) => {
          if (
            res['success'] === 0 ||
            res?.data?.comments?.length === 0 ||
            res?.data?.comments?.length < commentItemPerReq
          ) {
            setIsCommentLoading(false)
            setIsCommentLoadEnd(true)
            return
          }
          const { comments } = res.data
          setCommentsLastNumber(comments.length === 0 ? 0 : comments[comments.length - 1].no)
          setCommentList((list) => {
            return list.concat(comments)
          })
          setIsCommentLoading(false)
        },
      )
    }
  }
  const handleClickMore = (index) => {
    const feeds = feedList
    if (feeds[index]['is_show_desc']) {
      return
    }
    feeds[index]['is_show_desc'] = true
    setShowMoreFeedNoList([...showMoreFeedNoList, feeds[index]['no']])
    setFeedList(feeds)
  }
  const displayCornerCase = () => {
    return (
      <React.Fragment>
        {isEnd === true && feedList?.length === 0 && (
          <EmptyContainer>
            <EmptyContent>
              <EmptyImg src={uniFail} />
              <EmptyDesc>피드가 텅 비었어요</EmptyDesc>
              <EmptyActionBtn onClick={() => history.push('/')}>챌린지 둘러보기</EmptyActionBtn>
            </EmptyContent>
          </EmptyContainer>
        )}
      </React.Fragment>
    )
  }
  const displayLoadingIcon = () => {
    return isEnd === false && feedList?.length > 0 ? (
      <div style={{ padding: 'calc(100vw * (10 / 375)) 0' }}>
        <LottieLoader
          lottieFile={loadingAnimation}
          lottieOptions={{
            loop: true,
            autoplay: true,
            renderer: 'svg',
            animationData: loadingAnimation,
          }}
          style={{
            margin: 'auto',
            width: 'calc(100vw * (45 / 375))',
            height: 'calc(100vw * (45 / 375))',
          }}
        />
      </div>
    ) : null
  }
  return (
    <React.Fragment>
      {displayCornerCase()}
      <FeedListSection onScroll={handleScroll}>
        <AnimatedWindow windowOn={showFeedDetailList}>
          <AnimatedWindowHeader
            onBackBtn={() => {
              setShowFeedDetailList(false)
            }}
          />
          <FeedList
            feedList={feedList}
            userInfo={userInfo}
            addLikeRequest={addLikeRequest}
            deleteLikeRequest={deleteLikeRequest}
            handleBottomModalState={handleBottomModalState}
            commentVisible={commentVisible}
            commentList={commentList}
            currentFeedNo={currentFeedNo}
            handleFeedScroll={handleScroll}
            loadNextComments={loadNextComments}
            handleDoubleClick={handleDoubleClick}
            isLikeAnimation={isLikeAnimation}
            lottieOptions={{
              loop: false,
              autoplay: true,
              renderer: 'svg',
              animationData: likeAnimation,
            }}
            handleClickMore={handleClickMore}
            feedDescLimit={feedDescLimit}
            showMoreFeedNoList={showMoreFeedNoList}
            onTriggerCreateComment={handleCreateComment}
            onTriggerDeleteComment={handleDeleteComment}
            onClickComment={handleOpenCommentModal}
          />
          {commentVisible && currFeed ? (
            <TaskDetail
              currTaskNo={currFeed['task_no']}
              addLikeRequest={addLikeRequest}
              deleteLikeRequest={deleteLikeRequest}
              currentFeedNo={currentFeedNo}
              handleDoubleClick={handleDoubleClick}
              isLikeAnimation={isLikeAnimation}
              lottieOptions={{
                loop: false,
                autoplay: true,
                renderer: 'svg',
                animationData: likeAnimation,
              }}
              setCommentVisible={setCommentVisible}
              handleBottomModalState={handleBottomModalState}
              animation={true}
              isCommentSlideOn={isCommentSlideOn}
              setIsCommentSlideOn={setIsCommentSlideOn}
              deleteFeedRequest={deleteFeedRequest}
              onTriggerCreateComment={handleCreateComment}
              onTriggerDeleteComment={handleDeleteComment}
              onTriggerCreateLike={handleCreateLike}
              onTriggerDeleteLike={handleDeleteLike}
              onTriggerUpdateTask={handleUpdateTask}
              handleOpenReportModal={handleOpenReportModal}
              onDeleteTaskTrigger={handleDeleteTaskTrigger}
            />
          ) : null}
        </AnimatedWindow>
        <TaskResultFormModal
          visible={showTaskResultForm}
          taskNo={targetTaskNo}
          onSubmit={(response) => {
            const targetTask = response['data']
            const targetProof = response['data']['proof']

            const newFeedList = feedList.slice()
            for (let i = 0; i < newFeedList.length; ++i) {
              if (targetTask['task_no'] === newFeedList[i]['task_no']) {
                newFeedList[i]['proof'] = targetProof
                newFeedList[i]['description'] = targetTask['description']
              }
            }
            setFeedList(newFeedList)
            setShowTaskResultForm(false)
            setTargetTaskNo(null)
            if (onEdit) {
              onEdit(targetTask)
            }
          }}
          onClose={() => {
            setShowTaskResultForm(false)
            setTargetTaskNo(null)
          }}
          setSocialShareModalVisible={setSocialShareModalVisible}
        />
        {reportModalVisible && reportTargetNo ? (
          <TaskReportModal
            visible={reportModalVisible}
            setVisible={setReportModalVisible}
            reportTargetNo={reportTargetNo}
            setReportTargetNo={setReportTargetNo}
            onDeleteTaskTrigger={handleDeleteTaskTrigger}
            onReportComplete={handleReportComplete}
          />
        ) : null}
        <BottomModal
          visible={bottomModalVisible}
          setVisible={setBottomModalVisible}
          dataList={bottomModalDataList}
        />
        <CenterModal
          modalVisible={centerModalVisible}
          setModalVisible={setCenterModalVisible}
          dataList={centerModalDataList}
          onCancel={onModalCancel}
          onComplete={onModalComplete}
        />
        <FeedGalleryList
          userInfo={userInfo}
          feedList={feedList}
          onSelect={(feedItem) => {
            setShowFeedDetailList(true)
            //move to scroll
            document.getElementById(`feed-list-item-${feedItem['no']}`).scrollIntoView()
          }}
        />
        {displayLoadingIcon()}
      </FeedListSection>
    </React.Fragment>
  )
}

const FeedListSection = styled.div`
  height: 100%;
  overflow-y: scroll;
`

export const InfoSection = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: calc(100vw * (24 / 375)) calc(100vw * (17 / 375)) calc(100vw * (70 / 375));
`
export const InfoIconWrapper = styled.div`
  width: calc(100vw * (69 / 375));
  height: calc(100vw * (87 / 375));
  margin-bottom: calc(100vw * (8 / 375));
`
export const InfoIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
export const InfoTxt = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  /* or 19px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #7f7f7f;
`

export const EmptyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: calc(100vw * (24 / 375)) calc(100vw * (17 / 375)) calc(100vw * (70 / 375));
`

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const EmptyImg = styled.img`
  width: calc(100vw * (78 / 375));
  height: calc(100vw * (90 / 375));
  position: relative;
  left: calc(100vw * (-14 / 375));
  margin-bottom: calc(100vw * (11 / 375));
`

export const EmptyDesc = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (24 / 375));
  text-align: center;
  color: #7f7f7f;
  margin-bottom: calc(100vw * (21 / 375));
`

export const EmptyActionBtn = styled.button`
  background: #ffcf19;
  border-radius: calc(100vw * (10 / 375));
  padding: calc(100vw * (13 / 375)) calc(100vw * (22 / 375));
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (23 / 375));
  text-align: center;
  color: #000000;
`
